            
<template>  
  <div>
  	<div class="modalsave" v-show="saveConfig.capa"></div>
    <validation-observer v-slot="{ invalid }">
      <b-form  inline style="margin-bottom:15px" novalidate>
        <b-row>
                    <sw-inputs
                      inputTabla="datos_proveedores_lente"
                      inputCampo="documento"
                      :md="4"
                      :lg="4">
                    </sw-inputs>
                    <sw-inputs
                      inputTabla="datos_proveedores_lente"
                      inputCampo="name"
                      :md="4"
                      :lg="4">
                    </sw-inputs>
                    <sw-inputs
                      inputTabla="datos_proveedores_lente"
                      inputCampo="direccion"
                      :md="4"
                      :lg="4">
                    </sw-inputs>
                    <sw-inputs
                      inputTabla="datos_proveedores_lente"
                      inputCampo="ciudad"
                      :md="4"
                      :lg="4">
                    </sw-inputs>
                    <sw-inputs
                      inputTabla="datos_proveedores_lente"
                      inputCampo="telefonos"
                      :md="4"
                      :lg="4">
                    </sw-inputs>
                    <sw-inputs
                      inputTabla="datos_proveedores_lente"
                      inputCampo="email"
                      :md="4"
                      :lg="4">
                    </sw-inputs>    
        </b-row>
      </b-form>
      <footer  id="modal-1___BV_modal_footer_" class="modal-footer" style="margin: 0 -15px; padding: 0">
          <sw-saveform
            :index="indexData"
            nameBtn="Proveedor Lente"
            :invalid="invalid"
            @save="save"
            >
          </sw-saveform>
      </footer>
    </validation-observer>
  </div> 
</template>
<script>
import { mapState } from "vuex"
import { ValidationObserver } from 'vee-validate'
import SwInputs  from '@/components/forms/inputs.vue'
import SwSaveform from '@/components/forms/saveForm.vue'
export default 
{
  name: 'paciente',
  components: {
    SwInputs,
    ValidationObserver,
    SwSaveform        
  },
  props: {
  },
  created(){
    if(this.indexData!==false)
    {
      this.updateDataForm({data: this.dataGet[this.namePath].data[this.indexData]})
    }    
  },
  async beforeDestroy()
  {
    await this.resetGlobal({state: 'indexData'})
  },
  computed: { 
  },
  methods: {
    save(event)
    {
      this.$emit('save',{save: false, ftn: 'lenteEditarFtn' })
    }
  }
}
</script>
<style>
</style>